<template>
  <v-layout class="ma-0 pa-0" justify-space-between fluid fill-height ref="refSales">
    <KeyboardEvents v-on:keydown="globalKeyDown"></KeyboardEvents>

    <!-- <StreamBarcodeReader v-if="isOnAndroid" @decode="onDecodeBarcode" @loaded="onLoadedCamera"></StreamBarcodeReader> -->

    <loading
      :can-cancel="true"
      :on-cancel="
        () => {
          isLoading = false;
        }
      "
      :background-color="$vuetify.theme.dark ? '#000' : '#FFF'"
      :color="$vuetify.theme.dark ? '#FFF' : '#000'"
      loader="bars"
      :active.sync="isLoading"
      :opacity="0.92"
    >
      <span slot="after">
        <br />
        {{ loaderText }}
      </span>
    </loading>
    <v-dialog v-if="dialogFullscreen" v-model="dialogFullscreen" :overlay-opacity="0.92" @keydown="keyDownDialogFullScreen" persistent max-width="320" style="z-index: 9999999">
      <v-card>
        <v-card-title>Изглед на цял екран?</v-card-title>
        <v-card-actions class="mx-4">
          <span>Желаете ли приложението да бъде използвано на цял екран?</span>
        </v-card-actions>
        <v-card-actions class="mx-4" v-if="!isOnMobile">
          <span>Може да излезете по всяко време, с натискане на бутон ESC.</span>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogFullscreen = false" color="warning" tile>Отказ</v-btn>
          <v-btn
            @click="
              requestFullScreen();
              dialogFullscreen = false;
            "
            color="success"
            tile
            >ОК</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogSellArticle" v-model="dialogSellArticle" :overlay-opacity="0.9" @keydown="keyDownDialogSellArticle" persistent max-width="320" style="z-index: 9999999">
      <v-card>
        <v-card-title>Продажба?</v-card-title>
        <v-card-actions class="mx-4">
          <span>{{ currentQTY.toFixed(3) + " * " + currentArticle.PLUName }}</span>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="deep-orange" text @click="cancelDialogs()">Отказ</v-btn>
          <v-btn
            color="deep-orange"
            text
            @click="
              sell(currentArticle);
              cancelDialogs();
            "
            >ОК</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogFreePrice" v-model="dialogFreePrice" :overlay-opacity="0.9" @keydown="keyDownDialogFreePrice" persistent max-width="320" style="z-index: 9999999">
      <v-card>
        <v-card-title>Въведете свободна цена</v-card-title>
        <v-card-actions class="mx-4">
          <v-text-field v-model="freePriceWannaBe" @input="changeFreePrice" @focus="$event.target.select()" autofocus :rules="price_Rules"> </v-text-field>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="deep-orange"
            text
            @click="
              freePrice = null;
              freePriceWannaBe = null;
              cancelDialogs();
            "
            >Отказ</v-btn
          >
          <v-btn
            color="deep-orange"
            text
            @click="
              if (checkFreePrice()) {
                cancelDialogs();
              }
            "
            >ОК</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Storno v-if="fp.isInMode(Const.Modes.Storno)" @hook:destroyed="readReceiptInfo" />
    <Invoice v-if="fp.isInMode(Const.Modes.Invoice)" @hook:destroyed="readReceiptInfo" />
    <CreditNote v-if="fp.isInMode(Const.Modes.CreditNote)" @hook:destroyed="readReceiptInfo" />
    <Discount v-if="fp.isInMode(Const.Modes.DiscountOrAddition)" />
    <v-navigation-drawer v-if="!isOnMobile" app clipped permanent fill-height :right="!uiSettings.menuInLeft" class="elevation-2" :width="uiSettings.touchScreenMode ? 278 : 256">
      <v-container ref="refReceiptContainer" class="ma-0 pa-0 elevation-3" height="100%" :class="isOnMobile ? '' : 'fullheightparentcontainer'">
        <v-card style="user-select: none" class="mb-2" :height="receiptHeight" :max-height="receiptHeight">
          <v-row :style="'height: ' + Math.max(0, getPaperHeight() - receiptArticles.length * 80 - 1) + 'px;'"></v-row>
          <v-virtual-scroll :height="Math.min(getPaperHeight(), receiptArticles.length * 80 + 1)" id="receiptDiv" :items="receiptArticles" :item-height="80" min-width="0" width="100vw" :style="receiptClass && getPaperHeight() > receiptArticles.length * 80 ? 'overflow-y: hidden;' : ''">
            <template v-slot="{ item }">
              <v-list-item :class="receiptClass" class="ma-0 pa-0 mx-1 mt-2" :disabled="!isInReceipt">
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class="ma-0 pa-0">
                    <v-row class="ma-0 pa-0" justify="start" align="center">
                      <v-tooltip :disabled="isOnAndroid" top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" style="height: 22px" v-if="isInReceipt && !isPaymentStarted" color="error" text fab x-small @click="sell(item, true)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span class="caption">Корекция</span>
                      </v-tooltip>
                      <span class="subtitle-2">{{ item.PLUName }}</span>
                    </v-row>
                  </v-list-item-title>
                  <v-list-item-title v-if="item.Quantity != 1" class="ma-0 pa-0">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12" class="ma-0 pa-0 subtitle-2 text-end">{{ item.Quantity.toFixed(3) + " x " + (item.FreePrice ? item.FreePrice : item.Price).toFixed(2).padStart(24) + " €" }}</v-col>
                    </v-row>
                  </v-list-item-title>
                  <v-list-item-title class="ma-0 pa-0">
                    <v-row class="ma-0 pa-0 pl-8" justify="space-between">
                      <span class="ma-0 pa-0 subtitle-2">{{ "Сума: " }}</span>
                      <span class="ma-0 pa-0 subtitle-2 text-end">{{ item.Sum.toFixed(2).padStart(24) + " €" }}</span>
                      <!-- <v-col cols="3" he class="ma-0 pa-0 subtitle-2 text-left">{{ "Сума: " }}</v-col>
                      <v-col cols="7" class="ma-0 pa-0 subtitle-2 text-right">{{ item.Sum.toFixed(2).padStart(24) + " €" }}</v-col>-->
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-virtual-scroll>
          <v-divider></v-divider>
          <v-card-title class="darken-4 ma-0 pa-0 px-1">
            <v-row class="ma-0 pa-1" justify="center" align="center">
              <!-- <v-col cols="7" class="ma-0 pa-0 subtitle-1 text-start">{{ receiptTypeStr + ":" }}</v-col>
              <v-col cols="5" class="ma-0 pa-0 subtitle-1 text-end">{{ receiptHeaderMessage }}</v-col>
              <v-col cols="7" v-if="receiptFooterMessage" class="ma-0 pa-0 subtitle-1 text-start">Сума от клиента:</v-col>
              <v-col cols="5" v-if="receiptFooterMessage" class="ma-0 pa-0 subtitle-1 text-end">{{ receiptFooterMessage }}</v-col>
              <v-col cols="7" v-if="receiptFooterMessage2" class="ma-0 pa-0 subtitle-1 text-start">{{ receiptHasChange ? "Ресто:" : "Остатък:" }}</v-col>
              <v-col cols="5" v-if="receiptFooterMessage2" class="ma-0 pa-0 subtitle-1 text-end">{{ receiptFooterMessage2 }}</v-col>-->
              <v-col class="ma-0 pa-0 subtitle-1" cols="12">
                <v-row class="ma-0 pa-0" justify="space-between">
                  <span class="ma-0 pa-0">{{ receiptTypeStr + ":" }}</span>
                  <span class="ma-0 pa-0 text-end">{{ receiptHeaderMessage.trim() }}</span>
                </v-row>
              </v-col>
              <v-col v-if="receiptFooterMessage" class="ma-0 pa-0 subtitle-1" cols="12">
                <v-row class="ma-0 pa-0" justify="space-between">
                  <span class="ma-0 pa-0">{{ receiptFooterMessage0 }}</span>
                  <span class="ma-0 pa-0 text-end">{{ receiptFooterMessage.trim() }}</span>
                </v-row>
              </v-col>
              <v-col v-if="receiptFooterMessage2" class="ma-0 pa-0 subtitle-1" cols="12">
                <v-row class="ma-0 pa-0" justify="space-between">
                  <span class="ma-0 pa-0">{{ receiptHasChange ? "Ресто:" : "Остатък:" }}</span>
                  <span class="ma-0 pa-0 text-end">{{ receiptFooterMessage2.trim() }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>

        <v-row class="mа-0 pa-0 flex-grow-0" v-if="receiptCanBeCanceled || (cancelPaymentsButtonVisible && receiptCanBeCanceled && isPaymentStarted)">
          <v-col class="mа-0 pa-0" cols="12">
            <v-btn v-if="cancelPaymentsButtonVisible && receiptCanBeCanceled && isPaymentStarted" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" class="elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile @click="cancelPayments()">
              <v-icon color="#1685c9" left>mdi-cash-remove</v-icon>
              <span>Отказ на плащанията</span>
            </v-btn>
          </v-col>
          <v-col class="mа-0 pa-0 pb-3" cols="12">
            <v-btn v-if="receiptCanBeCanceled" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" class="elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile @click="cancelReceipt(false)">
              <v-icon color="#1685c9" left>mdi-sticker-remove-outline</v-icon>
              <span>Отказ на целия бон</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="growingchildcontainer"></v-row>
        <v-btn v-if="!isInReceipt" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" :disabled="isScaleMeasuring" @click="fp.addMode(Const.Modes.Storno)" class="ma-0 pa-2 mb-1 flex-grow-0 elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile>
          <v-icon color="#1685c9" left>mdi-sticker-minus-outline</v-icon>
          <span class="flex-grow-1 button-span">Сторно бон</span>
        </v-btn>
        <v-btn v-if="!isInReceipt" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" :disabled="isScaleMeasuring" @click="fp.addMode(Const.Modes.Invoice)" class="ma-0 pa-2 mb-1 flex-grow-0 elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile>
          <v-icon color="#1685c9" left>mdi-text-box-plus-outline</v-icon>
          <span class="flex-grow-1 button-span">Фактура</span>
        </v-btn>
        <v-btn v-if="!isInReceipt" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" :disabled="isScaleMeasuring" @click="fp.addMode(Const.Modes.CreditNote)" class="ma-0 pa-2 mb-1 flex-grow-0 elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile>
          <v-icon color="#1685c9" left>mdi-text-box-minus-outline</v-icon>
          <span class="flex-grow-1 button-span">Кредитно известие</span>
        </v-btn>
        <v-btn v-if="!isInReceipt" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" :disabled="isScaleMeasuring" @click="printDuplicate" class="ma-0 pa-2 mb-1 flex-grow-0 elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile>
          <v-icon color="#1685c9" left>mdi-content-copy</v-icon>
          <span class="flex-grow-1 button-span">Дубликат на последния бон</span>
        </v-btn>

        <v-row v-if="isInReceipt" class="pa-1 flex-grow-0">
          <v-col v-if="!isPaymentFinished" cols="6" class="mа-0 pa-1">
            <v-menu :open-on-click="uiSettings.showPaymentValues" top offset-y :nudge-left="-25" :nudge-top="15" :width="menuWidth - 10" class="ma-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-on="on" v-bind="attrs" @focus="$event.target.select()" @change="changeCurrentPayment" :value="currentPayment.toFixed(2)" name="CurrentAmount" hide-details outlined :dense="!uiSettings.touchScreenMode" required label="Сума от клиента" class="ma-0 pa-0 pl-2 centered-input"></v-text-field>
              </template>
              <v-card class="ma-0 pa-0" :width="menuWidth - 10">
                <v-row class="ma-0 pa-0">
                  <v-col cols="6" class="ma-0 pa-1">
                    <v-btn
                      @click="
                        changeCurrentPayment(50);
                        wantToPay();
                      "
                      :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''"
                      class="elevation-0 ma-0 pa-0"
                      :color="isInDarkMode ? '' : 'blue lighten-4'"
                      block
                      tile
                    >
                      <v-icon color="#1685c9" left>mdi-cash-check</v-icon>
                      <span>50.00 €</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="ma-0 pa-1">
                    <v-btn
                      @click="
                        changeCurrentPayment(100);
                        wantToPay();
                      "
                      :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''"
                      class="elevation-0 ma-0 pa-0"
                      :color="isInDarkMode ? '' : 'blue lighten-4'"
                      block
                      tile
                    >
                      <v-icon color="#1685c9" left>mdi-cash-check</v-icon>
                      <span>100.00 €</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <v-col cols="6" class="ma-0 pa-1">
                    <v-btn
                      @click="
                        changeCurrentPayment(10);
                        wantToPay();
                      "
                      :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''"
                      class="elevation-0 ma-0 pa-0"
                      :color="isInDarkMode ? '' : 'blue lighten-4'"
                      block
                      tile
                    >
                      <v-icon color="#1685c9" left>mdi-cash-check</v-icon>
                      <span>10.00 €</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="ma-0 pa-1">
                    <v-btn
                      @click="
                        changeCurrentPayment(20);
                        wantToPay();
                      "
                      :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''"
                      class="elevation-0 ma-0 pa-0"
                      :color="isInDarkMode ? '' : 'blue lighten-4'"
                      block
                      tile
                    >
                      <v-icon color="#1685c9" left>mdi-cash-check</v-icon>
                      <span>20.00 €</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <v-col cols="6" class="ma-0 pa-1">
                    <v-btn
                      @click="
                        changeCurrentPayment(2);
                        wantToPay();
                      "
                      :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''"
                      class="elevation-0 ma-0 pa-0"
                      :color="isInDarkMode ? '' : 'blue lighten-4'"
                      block
                      tile
                    >
                      <v-icon color="#1685c9" left>mdi-cash-check</v-icon>
                      <span>2.00 €</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="ma-0 pa-1">
                    <v-btn
                      @click="
                        changeCurrentPayment(5);
                        wantToPay();
                      "
                      :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''"
                      class="elevation-0 ma-0 pa-0"
                      :color="isInDarkMode ? '' : 'blue lighten-4'"
                      block
                      tile
                    >
                      <v-icon color="#1685c9" left>mdi-cash-check</v-icon>
                      <span>5.00 €</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>
          </v-col>
          <v-col v-if="!isPaymentFinished" cols="6" class="mа-0 pa-1">
            <v-select :items="paymentTypes" @change="changeCurrentPaymentType" :value="currentPaymentType" item-text="fdname" :readonly="!allowOtherPayments" hide-details outlined :dense="!uiSettings.touchScreenMode" class="ma-0 pa-0 pr-2 centered-input" label="Вид плащане"> </v-select>
          </v-col>
          <v-col v-if="!isPaymentFinished" cols="12" class="mа-0 pa-0 pt-3">
            <v-btn @click="wantToPay" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" class="elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile>
              <v-icon color="#1685c9" left>mdi-account-cash</v-icon>
              <span>Плащане</span>
            </v-btn>
          </v-col>
          <v-col v-if="isPaymentFinished" cols="12" class="mа-0 pa-0 pt-3">
            <v-btn @click="closeReceipt" :style="uiSettings.touchScreenMode ? 'height: 60px;' : ''" class="elevation-0" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile>
              <v-icon color="#1685c9" left>mdi-file-document-edit</v-icon>
              <span>Затваряне на бона</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-container ref="refButtonsContainer" fluid style="user-select: none" :style="`height: calc(100% - ${searchToolbarHeight + mobileReceiptHeight}px); top: ${(uiSettings.searchInTop ? searchToolbarHeight : 0) + mobileReceiptHeight}px;`" class="ma-0 pa-2 pt-4 salecontainer customscroll">
      <template v-if="getViewTypeIndex == 0 || getViewTypeIndex == 1 || getViewTypeIndex == 2">
        <v-virtual-scroll ref="refVirtualScroller" :height="virtualScrollContentHeight" :items="articlesFiltered2d" :item-height="buttonsHeight" justify="center">
          <template v-slot="{ item }">
            <v-row justify="center" align="center" class="ma-0 pa-0 fill-height">
              <v-hover v-for="plu in item" :key="plu.PLUNum" v-slot:default="{ hover }" style="cursor: pointer">
                <v-card :disabled="isPaymentStarted || isScaleMeasuring" @click="sell(plu)" class="ma-2" :class="plu == currentArticle ? ' my-selected-row' : ''" :elevation="hover ? 12 : 2" outlined :min-width="buttonsWidth" :max-width="buttonsWidth" v-ripple="isOnAndroid ? {} : { center: true }" :height="buttonsHeight - 10">
                  <v-tooltip top nudge-bottom="8px" :disabled="isOnAndroid || currentQTY == 1" :color="$vuetify.theme.dark ? 'rgba(100,100,100,0.8)' : ''">
                    <template v-slot:activator="{ on }">
                      <v-list-item v-on="on">
                        <v-list-item-content>
                          <!-- <v-img :width="50" :height="50" :src="plu.Image" contain></v-img> -->
                          <v-list-item-title align="center" class="subtitle-2 text-wrap ma-0 pa-0">{{ plu.PLUNum + ". " + plu.PLUName }}</v-list-item-title>
                          <v-list-item-subtitle v-if="getViewTypeIndex == 1 || getViewTypeIndex == 2">{{ (isWithSmallWidth ? "Деп: " : "Департамент: ") + (plu.BelongToDepNumber ? fp.departments[plu.BelongToDepNumber].DepName : "") }}</v-list-item-subtitle>
                          <v-list-item-subtitle v-if="getViewTypeIndex == 2">{{ "Баркод: " + (plu.Barcode ? plu.Barcode : "Не е програмиран") }}</v-list-item-subtitle>
                          <v-list-item-title class="subtitle-2">
                            <span v-if="!!freePrice && plu.OptionPrice" style="color: red"> {{ freePrice.toFixed(2) + " €" }}</span>
                            <span v-else> {{ plu.Price.toFixed(2) + " €" }}</span>
                            <span style="white-space: pre"> {{ " * " + plu.OptionVATClass }} </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <v-chip :color="$vuetify.theme.dark ? 'rgba(0,0,0,1)' : ''">{{ currentQTY.toFixed(3) + " x " }}</v-chip>
                  </v-tooltip>
                </v-card>
              </v-hover>
            </v-row>
          </template>
        </v-virtual-scroll>
      </template>
      <v-card class="ma-0 pa-0" v-if="getViewTypeIndex == 3 || getViewTypeIndex == 4" align="left" justify="center" width="98%" :height="virtualScrollContentHeight">
        <v-simple-table fixed-header class="ma-0 pa-0" :style="`left: 0; width: ` + tableHeaderWidthAll">
          <template v-slot:default>
            <thead class="ma-0 pa-0" ref="refHeaders">
              <tr class="ma-0 pa-0">
                <th v-if="!isWithSmallWidth" ref="refHeader1" class="text-center" :width="'50px'">{{ isWithSmallWidth ? "№" : "Номер" }}</th>
                <th ref="refHeader2" class="text-left" width="auto">Име</th>
                <th ref="refHeader3" class="text-center" :width="isWithSmallWidth ? '25%' : '15%'">Цена</th>
                <th ref="refHeader4" class="text-left" width="10%">Д.Г.</th>
                <th v-if="!isWithSmallWidth" ref="refHeader5" class="text-left" :width="'15%'">Деп.</th>
                <!-- <th v-if="!isWithSmallWidth" ref="refHeader6" class="text-center" :width="'20%'">Баркод</th> -->
              </tr>
            </thead>
          </template>
        </v-simple-table>
        <v-virtual-scroll ref="refTableScrollContent" :height="virtualScrollContentHeight - tableHeadersHeight" :max-height="virtualScrollContentHeight - tableHeadersHeight" :items="articlesFiltered" :item-height="(uiSettings.touchScreenMode ? 5 : 0) + (getViewTypeIndex == 3 ? 36 : 27)">
          <template v-slot="{ item }">
            <v-container @click="sell(item)" :disabled="isPaymentStarted || isScaleMeasuring" class="ma-0 pa-0" :class="(isPaymentStarted || isScaleMeasuring ? 'grey--text' : 'custom-table-row') + (item == currentArticle ? ' my-selected-row' : '')" width="100%" :style="(isPaymentStarted || isScaleMeasuring ? '' : 'cursor:pointer; height: 100%; display: block;') + 'height: ' + ((uiSettings.touchScreenMode ? 5 : 0) + (getViewTypeIndex == 3 ? 35 : 26)) + 'px'">
              <td :class="uiSettings.touchScreenMode ? 'subtitle-1' : ''" :width="tableHeaderWidth1" class="px-3 my-table-cell text-right" v-if="!isWithSmallWidth">{{ item.PLUNum }}</td>
              <td :class="uiSettings.touchScreenMode ? 'subtitle-1' : ''" :width="tableHeaderWidth2" class="px-3 my-table-cell text-left">{{ item.PLUName }}</td>
              <td v-if="!!freePrice && item.OptionPrice" :class="uiSettings.touchScreenMode ? 'subtitle-1' : ''" :width="tableHeaderWidth3" class="px-3 my-table-cell text-right" style="color: red">{{ freePrice.toFixed(2) }}</td>
              <td v-else :class="uiSettings.touchScreenMode ? 'subtitle-1' : ''" :width="tableHeaderWidth3" class="px-3 my-table-cell text-right">{{ item.Price.toFixed(2) }}</td>
              <td :class="uiSettings.touchScreenMode ? 'subtitle-1' : ''" :width="tableHeaderWidth4" class="px-3 my-table-cell text-center">{{ item.OptionVATClass }}</td>
              <!-- <td :width="tableHeaderWidth5" class="pl-4 pr-4 my-table-cell text-center" v-if="!isWithSmallWidth">{{ item.BelongToDepNumber }}</td> -->
              <td :class="uiSettings.touchScreenMode ? 'subtitle-1' : ''" :width="tableHeaderWidth5" class="pl-4 pr-4 my-table-cell text-left" v-if="!isWithSmallWidth && fp.departments[item.BelongToDepNumber]">{{ fp.departments[item.BelongToDepNumber].DepName }}</td>
              <!-- <td :width="tableHeaderWidth6" class="pl-4 pr-4 my-table-cell text-right" v-if="!isWithSmallWidth">{{ item.Barcode }}</td> -->
            </v-container>
            <v-divider class="ma-0 pa-0"></v-divider>
          </template>
        </v-virtual-scroll>
      </v-card>
    </v-container>
    <v-app-bar absolute elevation-3 :bottom="!uiSettings.searchInTop" :style="`top: ${mobileReceiptHeight + (uiSettings.searchInTop ? 0 : contentHeight)}px; bottom: 0px;`" :height="searchToolbarHeight" :min-height="searchToolbarHeight" :max-height="searchToolbarHeight" min-width="100%" width="100%">
      <v-card class="ma-0 pa-0" width="100%" max-width="100%" min-width="100%" :height="searchToolbarHeight" style="vertical-align: middle">
        <v-row class="box-container-horizontal ma-0 pa-0" style="height: 100%">
          <!-- <v-col cols="12" :xl="isOnAndroid?9:10" :lg="isOnAndroid?9:10" :md="isOnAndroid?8:9" :sm="isOnAndroid?8:9" :xs="isOnAndroid?6:7" class="pt-2"> 
            <v-text-field ref="refSearchTextField" v-model="searchText" @keydown="searchKeyDown" outlined dense label="Търсене на артикул" placeholder required></v-text-field>         
          </v-col>
          <v-col v-if="isOnAndroid" cols="12" xl="1" lg="1" md="1" sm="1" xs="1" class="pt-2">
            <ImageBarcodeReader style="color: rgba(0,0,0,0);"
                  @decode="onDecodeBarcode"
                  @error="onErrorBarcode"
              ></ImageBarcodeReader>
          </v-col>-->

          <div class="row-content ma-0">
            <v-text-field class="ma-0 pa-0 mx-2 mt-5" :autofocus="!isOnAndroid" ref="refSearchTextField" v-model="searchText" @keydown="searchKeyDown" @keyup="searchKeyUp" @keypress.stop label="Търсене на артикул" hide-details required></v-text-field>
          </div>
          <div v-if="!isWithSmallWidth" class="row-header ma-0" style="max-width: 160px">
            <v-select class="ma-0 pa-0 mx-2 mt-5" dense item-text="DepName" :items="getAvailableDeps" v-model="currentDepartment" hide-details return-object label="Департамент">
              <template slot="prepend-inner">
                <v-icon v-if="currentDepartment" class="ma-0 mt-1 pa-0" color="#1685c9" @click="currentDepartment = null">mdi-close</v-icon>
              </template>
            </v-select>
          </div>
          <div class="row-header ma-0 pa-0" v-if="uiSettings.showFreePrice">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon class="ma-2 pa-1" :large="!uiSettings.touchScreenMode" :x-large="uiSettings.touchScreenMode" :disabled="isScaleMeasuring" v-on="on" @click="dialogFreePrice = true" color="#1685c9">mdi-clipboard-edit-outline</v-icon>
              </template>
              Въведи свободна цена за следваща продажба:
            </v-tooltip>
          </div>
          <div class="row-header ma-0 pa-0" :style="isOnMobile ? 'max-width: 160px' : 'max-width: 200px'">
            <v-text-field class="centered-input ma-0 pa-0 px-2 mt-5" @focus="$event.target.select()" @change="changeCurrentQuantity" :value="getCurrentQuantity" name="Quantity" type="number" label="Количество" hide-details :rules="quantity_Rules">
              <template slot="prepend">
                <v-icon :class="uiSettings.touchScreenMode ? 'append-prepend-icon' : ''" @click="decrementQty" :large="uiSettings.touchScreenMode" color="#1685c9">mdi-minus-circle</v-icon>
              </template>
              <template slot="append-outer">
                <v-icon :class="uiSettings.touchScreenMode ? 'append-prepend-icon' : ''" @click="incrementQty" :large="uiSettings.touchScreenMode" color="#1685c9">mdi-plus-circle</v-icon>
              </template>
            </v-text-field>
          </div>
          <div class="row-header ma-0 pa-0">
            <v-tooltip v-if="fp.hasScale()" top>
              <template v-slot:activator="{ on }">
                <v-icon class="ma-2 pa-1" :large="!uiSettings.touchScreenMode" :x-large="uiSettings.touchScreenMode" :disabled="isScaleMeasuring" v-on="on" @click="getScaleQty" color="#1685c9">mdi-scale-balance</v-icon>
              </template>
              Вземи текущото количество от везната
            </v-tooltip>
          </div>
          <div class="row-header ma-0 pa-0">
            <v-tooltip v-if="uiSettings.showDrawerButton && !isOnAndroid && !isOnPhone" top>
              <template v-slot:activator="{ on }">
                <v-icon class="ma-2 pa-1 mr-4" :large="!uiSettings.touchScreenMode" :x-large="uiSettings.touchScreenMode" :disabled="isScaleMeasuring" v-on="on" @click="openCashDrawer()" color="#1685c9">mdi-cash-lock-open</v-icon>
              </template>
              Отвори чекмедже
            </v-tooltip>
          </div>
        </v-row>
      </v-card>
    </v-app-bar>
    <v-app-bar v-if="isOnMobile" absolute prominent :style="`top: 0px; bottom: auto; z-index: 3;`" :height="mobileReceiptHeight" :min-height="mobileReceiptHeight" min-width="100%" width="100%" class="ma-0 pa-0 elevation-0">
      <v-expansion-panels>
        <v-expansion-panel v-if="isInReceipt">
          <v-expansion-panel-header>
            <v-row class="ma-0 pa-0" justify="center" align="center">
              <v-col cols="12" class="ma-0 pa-0 subtitle-2">
                <v-row class="ma-0 pa-0" justify="space-between">
                  <span class="ma-0 pa-0">{{ receiptTypeStr + ":" }}</span>
                  <span class="ma-0 pa-0 text-end">{{ receiptHeaderMessage.trim() }}</span>
                </v-row>
              </v-col>
              <v-col v-if="receiptFooterMessage" class="ma-0 pa-0 subtitle-2" cols="12">
                <v-row class="ma-0 pa-0" justify="space-between">
                  <span class="ma-0 pa-0">{{ receiptFooterMessage0 }}</span>
                  <span class="ma-0 pa-0 text-end">{{ receiptFooterMessage.trim() }}</span>
                </v-row>
              </v-col>
              <v-col v-if="receiptFooterMessage2" class="ma-0 pa-0 subtitle-2" cols="12">
                <v-row class="ma-0 pa-0" justify="space-between">
                  <span class="ma-0 pa-0">{{ receiptHasChange ? "Ресто:" : "Остатък:" }}</span>
                  <span class="ma-0 pa-0 text-end">{{ receiptFooterMessage2.trim() }}</span>
                </v-row>
              </v-col>
              <!-- <v-col cols="7" class="ma-0 pa-0 subtitle-2 text-start">{{ receiptTypeStr + ":" }}</v-col>
              <v-col cols="5" class="ma-0 pa-0 subtitle-2 text-end">{{ receiptHeaderMessage }}</v-col>
              <v-col cols="7" v-if="receiptFooterMessage" class="ma-0 pa-0 subtitle-2 text-start">Сума от клиента:</v-col>
              <v-col cols="5" v-if="receiptFooterMessage" class="ma-0 pa-0 subtitle-2 text-end">{{ receiptFooterMessage }}</v-col>
              <v-col cols="7" v-if="receiptFooterMessage2" class="ma-0 pa-0 subtitle-2 text-start">{{ receiptHasChange ? "Ресто:" : "Остатък:" }}</v-col>
              <v-col cols="5" v-if="receiptFooterMessage2" class="ma-0 pa-0 subtitle-2 text-end">{{ receiptFooterMessage2 }}</v-col>-->
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="ma-0 pa-0" style="padding-left: 0px; padding-right: 0px">
            <div class="ma-0 pa-0" ref="refReceiptContainer" :style="`width: 100vw; height: ${mobileReceiptHeightExpanded}px;`">
              <v-virtual-scroll class="ma-0 pa-0" min-width="100vw" width="100vw" :height="mobileReceiptHeightExpanded - mobileReceiptCancelButtonHeight" :max-height="mobileReceiptHeightExpanded - mobileReceiptCancelButtonHeight" id="receiptDiv" :items="receiptArticles" :item-height="70">
                <template v-slot="{ item }">
                  <v-row class="ma-0 pa-0 subtitle-2" justify="start" align="center" style="align-content: center; height: 20px">
                    <v-tooltip :disabled="isOnAndroid" top>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" v-if="isInReceipt && !isPaymentStarted" color="error" text fab x-small @click="sell(item, true)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span class="caption">Корекция</span>
                    </v-tooltip>
                    <span class="ma-0 pa-1 subtitle-2">{{ item.PLUName }}</span>
                  </v-row>
                  <v-row v-if="item.Quantity != 1" class="ma-0 pa-0" justify="space-around" style="align-content: center; height: 20px">
                    <v-col cols="1" class="ma-0 pa-0"></v-col>
                    <v-col cols="11" class="ma-0 pa-0 subtitle-2 text-right">{{ item.Quantity.toFixed(3) + " x " + item.Price.toFixed(2) + " €" }}</v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0" justify="space-around" style="align-content: center; height: 20px">
                    <v-col cols="2" class="ma-0 pa-0"></v-col>
                    <v-col cols="3" class="ma-0 pa-0 subtitle-2 text-left">{{ "Сума: " }}</v-col>
                    <v-col cols="7" class="ma-0 pa-0 subtitle-2 text-right">{{ item.Sum.toFixed(2).padStart(24) + " €" }}</v-col>
                    <!-- <span class="subtitle-2">{{ "Сума: " }}</span>
                          <span class="subtitle-2" v-if="item.Quantity != 1">{{ item.Quantity.toFixed(3) + " x " + item.Price.toFixed(2).padStart(24) + " €" }}</span>
                    <span class="subtitle-2" v-else>{{ item.Price.toFixed(2).padStart(24) + " €" }}</span>-->
                  </v-row>
                </template>
              </v-virtual-scroll>
              <v-btn v-if="cancelPaymentsButtonVisible && receiptCanBeCanceled && isPaymentStarted" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="mt-5 elevation-0" @click="cancelPayments()">
                <v-icon color="#1685c9" left>mdi-cash-remove</v-icon>
                <span>Отказ на плащанията</span>
              </v-btn>
              <v-btn v-if="receiptCanBeCanceled" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="mt-1 elevation-0" @click="cancelReceipt(false)">
                <v-icon color="#1685c9" left>mdi-sticker-remove-outline</v-icon>
                <span>Отказ на целия бон</span>
              </v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-else>
          <v-expansion-panel-header>
            <v-row class="ma-0 pa-0" justify="center" align="center">
              <v-col cols="12" class="ma-0 pa-0">Операции с бонове</v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="pa-0 pl-4 pr-4 ma-0">
              <v-row class="pb-1">
                <v-btn @click="fp.addMode(Const.Modes.Storno)" :disabled="isScaleMeasuring" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0">
                  <v-icon color="#1685c9" left>mdi-sticker-minus-outline</v-icon>
                  <span class="flex-grow-1 button-span">Сторно бон</span>
                </v-btn>
              </v-row>
              <v-row class="pb-1">
                <v-btn @click="fp.addMode(Const.Modes.Invoice)" :disabled="isScaleMeasuring" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0">
                  <v-icon color="#1685c9" left>mdi-text-box-plus-outline</v-icon>
                  <span class="flex-grow-1 button-span">Фактура</span>
                </v-btn>
              </v-row>
              <v-row class="pb-1">
                <v-btn @click="fp.addMode(Const.Modes.CreditNote)" :disabled="isScaleMeasuring" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0">
                  <v-icon color="#1685c9" left>mdi-text-box-minus-outline</v-icon>
                  <span class="flex-grow-1 button-span">Кредитно известие</span>
                </v-btn>
              </v-row>
              <v-row class="pb-0">
                <v-btn @click="printDuplicate" :disabled="isScaleMeasuring" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0">
                  <v-icon color="#1685c9" left>mdi-content-copy</v-icon>
                  <span class="flex-grow-1 button-span">Дубликат на последния бон</span>
                </v-btn>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-app-bar>
    <v-footer v-if="isOnMobile && isInReceipt" app style="z-index: 2" class="font-weight-medium ma-0 pa-0 elevation-5">
      <v-card width="100%" height="100%">
        <v-row width="100%" height="100%" justify="center" align="center" class="ma-0 pa-2">
          <v-col v-if="!isPaymentFinished" cols="4" class="mа-0 pa-0">
            <v-text-field @focus="$event.target.select()" @change="changeCurrentPayment" :value="currentPayment.toFixed(2)" name="CurrentAmount" type="number" :label="isOnMobile ? 'Сума' : 'Сума от клиента'" class="ma-0 pa-0 centered-input" hide-details outlined dense required></v-text-field>
          </v-col>
          <v-col v-if="!isPaymentFinished" cols="5" class="mа-0 pa-0 pl-1">
            <v-select :items="paymentTypes" @change="changeCurrentPaymentType" :value="currentPaymentType" item-text="fdname" :readonly="!allowOtherPayments" dense hide-details outlined class="ma-0 mr-0" label="Вид плащане"></v-select>
          </v-col>
          <v-col v-if="!isPaymentFinished" cols="3" class="mа-0 pa-0 pl-1">
            <v-btn @click="wantToPay" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0">
              <v-icon color="#1685c9" left>mdi-account-cash</v-icon>
              <span v-if="!isWithSmallWidth">Плащане</span>
            </v-btn>
          </v-col>
          <v-col cols="12" class="mа-0 pa-0 pl-1">
            <v-btn @click="closeReceipt" v-if="isPaymentFinished" :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0">
              <v-icon color="#1685c9" left>mdi-file-document-edit</v-icon>
              <span>Затваряне на бона</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-footer>
  </v-layout>
</template>

<script>
import Const from "../constants.js";
import Tremol from "../assets/fp/fp";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import KeyboardEvents from "./KeyboardEvents.vue";
import Storno from "./StornoView.vue";
import CreditNote from "./CreditNote.vue";
import Invoice from "./InvoiceView.vue";
import Discount from "./DiscountView.vue";
// import $ from "jquery";
// import { StreamBarcodeReader } from "vue-barcode-reader";
require("../assets/IntersectionObserverPolyfill");

export default {
  components: {
    Loading,
    KeyboardEvents,
    Storno,
    Invoice,
    CreditNote,
    Discount,
    // StreamBarcodeReader
    //ImageBarcodeReader
  },
  data() {
    return {
      displayTO: null,
      receiptWasCanceled: false,
      receiptHeight: 300,
      cancelPaymentsButtonVisible: false,
      receiptMaximumAmount: 10000,
      dialogFullscreen: false,
      dialogSellArticle: false,
      dialogFreePrice: false,
      dialogScale: false,
      lastKbdKey: null,
      barcodeKbdBuffer: "",
      barcodeTimeoutFunction: null,
      barcodeInputMaxTimeout: 200,
      Const: Const,
      isWorking: false,
      isScaleMeasuring: false,
      loaderText: "",
      receiptTypes: {
        Sale: "Продажба",
        Invoice: "Фактура",
        Storno: "Сторно бон",
        CreditNote: "Кредитно известие",
      },
      receiptTypeStr: "Продажба",
      receiptText: "",
      receiptPaymentAmount: 0,
      receiptChange: 0,
      receiptClass: "",
      receiptIsOpen: false,
      currentArticle: null,
      currentQTY: 1,
      currentPayment: 0,
      currentPaymentType: null,
      paymentTypes: [],
      loaderValue: 0,
      articleFrom: 1,
      freePrice: null,
      freePriceWannaBe: null,
      currentDepartment: null,
      articleTo: 100000,
      clientsCount: 100,
      intervalRecalcSize: null,
      receiptArticles: [],
      articleLimit: Const.ArticleLimits[0], //this.uiSettings.articleLimit,
      searchText: "",
      isLoading: false,
      btnsPerRow: 3,
      tableHeaderWidthAll: "100%",
      tableHeaderWidth1: 0,
      tableHeaderWidth2: 0,
      tableHeaderWidth3: 0,
      tableHeaderWidth4: 0,
      tableHeaderWidth5: 0,
      tableHeaderWidth6: 0,
      tableHeadersHeight: 0,
      contentHeight: 1280,
      xDown: false,
      yDown: false,
      wasMoved: false,
      mobileReceiptHeightExpanded: 0,
      quantity_Rules: [
        (v) => {
          return v > 0 || "Невалидно количество!";
        },
        (v) => {
          return v < 9999 || "Невалидно количество!";
        },
      ],
      price_Rules: [
        (v) => {
          if (!!v && v != 0) {
            return true;
          } else {
            return "Невалидна цена!";
          }
        },
        (v) => {
          return /^(\d{1,6}|\d{0,6}\.\d{1,2})$/.test(v) || "Невалидна цена!";
        },
        (v) => {
          return (!!v && v.toString().length <= 9) || "Цената не може да превишава 9 символа!";
        },
      ],
    };
  },
  computed: {
    getAvailableDeps() {
      return this.fp.departments.filter((f) => !f.DepName.toUpperCase().startsWith("ДЕП") || this.fp.articles.find((a) => a.BelongToDepNumber == f.DepNum));
    },
    receiptFooterMessage0() {
      return this.receiptWasCanceled ? "" : "Сума от клиента:";
    },
    /** @return {Boolean} */
    isPaymentStarted() {
      return this.receiptPaymentAmount > 0 && this.receiptIsOpen;
    },
    /** @return {Boolean} */
    isPaymentFinished() {
      return this.receiptPaymentAmount > 0 && this.receiptPaymentAmount >= this.getReceiptAmount();
    },
    /** @return {Boolean} */
    isInReceipt() {
      return this.receiptIsOpen; // this.receiptArticles != null;
    },
    /** @return {Boolean} */
    receiptCanBeCanceled() {
      return this.isInReceipt && (this.fp.isNew || !this.isPaymentStarted);
    },
    /** @return {Boolean} */
    allowOtherPayments() {
      return this.receiptTypeStr == this.receiptTypes.Sale || this.receiptTypeStr == this.receiptTypes.Invoice;
    },
    /** @return {String} */
    receiptHeaderMessage() {
      return this.receiptAmount.toFixed(2).padStart(16);
    },
    /** @return {String} */
    receiptFooterMessage() {
      return this.receiptWasCanceled ? "Анулиран бон" : this.receiptPaymentAmount ? this.receiptPaymentAmount.toFixed(2).padStart(16) : null;
    },
    /** @return {String} */
    receiptFooterMessage2() {
      var change = this.receiptPaymentAmount - this.getReceiptAmount();
      return this.receiptPaymentAmount > 0 ? (change >= 0 ? change.toFixed(2).padStart(16) : (-change).toFixed(2).padStart(16)) : null;
    },
    /** @return {Boolean} */
    receiptHasChange() {
      return this.receiptPaymentAmount >= this.getReceiptAmount();
    },
    /** @return {Number} */
    receiptAmount() {
      return this.getReceiptAmount();
    },
    /** @return {Number} */
    virtualScrollContentHeight() {
      return this.contentHeight - 24;
    },
    /** @return {Number} */
    mobileReceiptCancelButtonHeight() {
      var h = this.receiptCanBeCanceled ? (this.isPaymentStarted && this.cancelPaymentsButtonVisible ? 90 : 50) : 0;
      if (this.receiptHeaderMessage) h += 20;
      if (this.receiptFooterMessage) h += 20;
      if (this.receiptFooterMessage2) h += 20;
      return h;
    },
    /** @return {Boolean} */
    isWithSmallWidth() {
      return this.isWindowNotWideEnough;
    },
    /** @return {Number} */
    buttonsPerRow() {
      return this.btnsPerRow;
    },
    /** @return { Array } */
    articlesFiltered() {
      return this.fp.articles.filter((a) => a.isVisible && a.Price > 0 && a.OptionVATClass >= "А" && a.OptionVATClass <= "Г" && (!this.currentDepartment || this.currentDepartment.DepNum == a.BelongToDepNumber));
    },
    /** @return { Array } */
    articlesFiltered2d() {
      var arts = this.articlesFiltered;
      var arrayLength = arts.length;
      if (arrayLength == 0) return [[]];
      var tempArray = [];
      for (var index = 0; index < arrayLength; index += this.buttonsPerRow) {
        var end = arrayLength <= this.buttonsPerRow + index ? arrayLength : index + this.buttonsPerRow;
        var myChunk = arts.slice(index, end);
        // Do something if you want with the group
        tempArray.push(myChunk);
      }
      return tempArray;
    },
    /** @return {Number} */
    getViewTypeIndex() {
      return Const.ViewTypes.indexOf(this.uiSettings.viewType);
    },
    /** @return {String} */
    getCurrentQuantity() {
      return this.currentQTY.toFixed(3);
    },
    buttonsHeight() {
      switch (this.getViewTypeIndex) {
        case 0:
          return 65;
        case 1:
          return 85;
        case 2:
          return 100;
        case 3:
        case 4:
        default:
          return -1;
      }
    },
    buttonsWidth() {
      return 280;
    },
  },
  methods: {
    getPaperHeight() {
      return this.receiptFooterMessage || this.receiptFooterMessage2 ? this.receiptHeight - 100 : this.receiptHeight - 50;
    },
    recalcWidthHeight() {
      if (this.intervalRecalcSize) clearInterval(this.intervalRecalcSize);
      this.intervalRecalcSize = setTimeout(() => {
        this.contentHeight = window.innerHeight - this.searchToolbarHeight - this.mobileReceiptHeight - this.headerFooterHeight;
        this.receiptHeight = this.contentHeight - 4 * (this.uiSettings.touchScreenMode ? 70 : 44) + this.searchToolbarHeight;
        var containerWi = window.innerWidth - this.$vuetify.application.right - this.$vuetify.application.left;
        //var containerWi = this.$refs.refButtonsContainer.clientWidth;
        var butWi = this.buttonsWidth + 20;
        var bpr = Math.trunc((containerWi - 20) / butWi);
        if (bpr < 1) bpr = 1;
        this.btnsPerRow = bpr;
        if (this.$refs.refHeaders) {
          this.tableHeadersHeight = this.$refs.refHeaders.clientHeight;
          this.tableHeaderWidth2 = this.$refs.refHeader2.clientWidth;
          this.tableHeaderWidth3 = this.$refs.refHeader3.clientWidth;
          this.tableHeaderWidth4 = this.$refs.refHeader4.clientWidth;
          if (!this.isWithSmallWidth) {
            this.tableHeaderWidth1 = this.$refs.refHeader1.clientWidth;
            this.tableHeaderWidth5 = this.$refs.refHeader5.clientWidth;
            // this.tableHeaderWidth6 = this.$refs.refHeader6.clientWidth;
          }
          var tbd = this.$refs.refTableScrollContent;
          if (tbd != undefined && tbd.$el != undefined && !this.isWithSmallWidth) {
            this.tableHeaderWidthAll = tbd.$el.scrollHeight > tbd.$el.clientHeight ? "calc(100% - 16px)" : "100%";
          } else {
            this.tableHeaderWidthAll = "100%";
          }
        }
        if (this.$refs.refSales.clientHeight) {
          this.mobileReceiptHeightExpanded = this.$refs.refSales.clientHeight - this.mobileReceiptHeight;
        }
      }, 333);
    },
    async onDecodeBarcode(result) {
      var foundPluBarcode = this.fp.articles.filter((article) => {
        return article.Barcode && article.Barcode.trim() === result;
      });
      if (foundPluBarcode && foundPluBarcode.length === 1) {
        await this.sell(foundPluBarcode[0]);
      }
    },
    onErrorBarcode() {
      this.fp.setErrorMessage("Неразпознат баркод!");
    },
    onLoadedCamera() {
      this.fp.setErrorMessage("Камера - работи!");
    },
    keyDownDialogFullScreen(e) {
      e.preventDefault();
      switch (e.keyCode) {
        case 173: //-
        case 109: //-
          this.cancelDialogs();
          break;
        case 13: // enter
          this.requestFullScreen();
          this.cancelDialogs();
          break;
        default:
          break;
      }
    },
    keyDownDialogFreePrice(e) {
      switch (e.keyCode) {
        case 27: // ESC
          e.preventDefault();
          this.freePrice = null;
          this.cancelDialogs();
          break;
        case 13: // enter
          e.preventDefault();
          if (this.checkFreePrice()) {
            this.cancelDialogs();
          }
          break;
        default:
          break;
      }
    },
    keyDownDialogSellArticle(e) {
      e.preventDefault();
      switch (e.keyCode) {
        case 173: //-
        case 109: //-
          this.cancelDialogs();
          break;
        case 13: // enter
          this.sell(this.currentArticle);
          this.cancelDialogs();
          break;
        default:
          break;
      }
    },
    searchKeyDown(e) {
      //console.log(e.keyCode);
      //console.log(e.key);
      if (((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) && this.searchText == "/") {
        e.preventDefault();
        var pt = Number(e.key);
        if (this.isInReceipt) {
          if (this.paymentTypes.length > pt) {
            this.currentPaymentType = this.paymentTypes[pt];
          }
          this.searchText = "";
        } else {
          if (pt == 1) {
            this.fp.addMode(Const.Modes.Storno);
          } else if (pt == 2) {
            this.fp.addMode(Const.Modes.Invoice);
          } else if (pt == 3) {
            this.fp.addMode(Const.Modes.CreditNote);
          }
        }
        return;
      }
      switch (e.keyCode) {
        case 106: // *
          if (this.changeCurrentQuantity(this.searchText)) {
            e.preventDefault();
            this.searchText = "";
          }
          break;

        case 61: //= (+ без шифт)
        case 107: //+
          if (this.searchText == "") {
            e.preventDefault();
            this.incrementQty();
          } else {
            var pluNum = Number(this.searchText.replaceAll(",", "."));
            if (pluNum) {
              var foundPlu = this.fp.articles.filter((article) => {
                return article.PLUNum == pluNum;
              });
              if (foundPlu.length == 1) {
                this.currentArticle = foundPlu[0];
                if (this.uiSettings.noConfirmOnKeyboardSale) {
                  this.sell(this.currentArticle);
                } else {
                  this.dialogSellArticle = true;
                }

                e.preventDefault();
                this.fp.articles.forEach((a) => {
                  a.isVisible = true;
                });
                this.searchText = "";
                return;
              }
            }
          }
          break;

        case 173: //-
        case 109: //-
          this.isLoading = false;
          if (this.searchText == "") {
            e.preventDefault();
            this.decrementQty();
          }
          break;

        case 111: // /
          if (this.searchText != "") {
            var paySum = Number(this.searchText.replaceAll(",", "."));
            if (paySum) {
              e.preventDefault();
              this.currentPayment = paySum;
              this.searchText = "";
            }
          }
          break;
        case 13: // enter
          if (this.searchText == "/") {
            setTimeout(async () => {
              await this.wantToPay(true);
            }, 1);
            e.preventDefault();
            return;
          } else {
            var artz = this.fp.articles.filter((f) => f.isVisible);
            if (artz.length == 1) {
              this.currentArticle = artz[0];
              if (this.searchText != this.barcodeKbdBuffer) {
                this.dialogSellArticle = true;
              }
              e.preventDefault();
              this.fp.articles.forEach((a) => {
                a.isVisible = true;
              });
              this.searchText = "";
              return;
            }
          }
          break;

        default:
          break;
      }
    },
    searchKeyUp() {
      // switch (e.keyCode) {
      //   case 13:
      //   case 111: // /
      //     return;
      //   default:
      //     break;
      // }
      this.fp.articles.forEach((article) => (article.isVisible = (article.Barcode && article.Barcode.trim() === this.searchText) || article.PLUName.toLowerCase().includes(this.searchText.toLowerCase())));
    },
    globalKeyDown(e) {
      switch (e.keyCode) {
        case 173: //-
        case 109: //-
          this.isLoading = false;
          break;
        case 27: // ESC
          e.preventDefault();
          break;
        default:
          break;
      }
      //var searchIsOnFocus = this.$refs.refSearchTextField.$el.contains(document.activeElement);
      if (this.fp.mode != Const.Modes.Sales) {
        return;
      }
      if (this.barcodeTimeoutFunction) {
        clearTimeout(this.barcodeTimeoutFunction);
      }
      if (this.lastKbdKey == 13 && e.keyCode == 13) {
        this.$refs.refSearchTextField.focus();
      }
      this.lastKbdKey = e.keyCode;
      if (e.keyCode == 13 && this.barcodeKbdBuffer.length > 7) {
        //console.log(this.barcodeKbdBuffer);
        var foundPluBarcode = this.fp.articles.filter((article) => {
          return article.Barcode && article.Barcode.trim() === this.barcodeKbdBuffer;
        });
        this.barcodeKbdBuffer = ""; //this.barcodeKbdBuffer.substring(bc.length);
        if (foundPluBarcode && foundPluBarcode.length === 1) {
          this.searchText = "";
          this.sell(foundPluBarcode[0]);
        }
      } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
        //само цифри
        this.barcodeKbdBuffer += e.key;
      } else {
        //this.barcodeKbdBuffer = "";
      }
      this.barcodeTimeoutFunction = setTimeout(() => {
        this.barcodeKbdBuffer = "";
      }, this.barcodeInputMaxTimeout);
    },
    checkFreePrice() {
      if (!this.freePriceWannaBe) {
        return false;
      }
      var num = Number(this.freePriceWannaBe);
      if (!num) {
        return false;
      }
      this.freePriceWannaBe = num;
      if (this.freePriceWannaBe == 0) {
        this.freePriceWannaBe = null;
        return false;
      }
      if (this.freePriceWannaBe > 9999) {
        this.freePriceWannaBe = 9999;
        return false;
      }
      this.freePrice = this.freePriceWannaBe;
      return true;
    },
    changeFreePrice() {
      if (this.freePriceWannaBe) {
        this.freePriceWannaBe = this.freePriceWannaBe.replaceAll(",", ".");
      }
    },
    changeCurrentQuantity(value) {
      this.currentQTY = Number(value.replaceAll(",", "."));
      if (!this.currentQTY) {
        this.currentQTY = -1;
        this.$nextTick(() => {
          this.currentQTY = 1;
        });
        return false;
      }
      if (this.currentQTY == 0) {
        this.currentQTY = 1;
      }
      if (this.currentQTY > 9999) {
        this.currentQTY = 9999;
      }
      return true;
    },
    changeCurrentPayment(value) {
      var val = value.toString();
      this.currentPayment = Number(val.replace(",", "."));
      if (!this.currentPayment) {
        this.currentPayment = -1;
        this.$nextTick(() => {
          this.currentPayment = 0;
        });
      } else {
        this.currentPayment = this.roundTo(this.currentPayment, 2);
      }
    },
    changeCurrentPaymentType(value) {
      this.currentPaymentType = this.paymentTypes.find((p) => p.fdname == value);
    },
    incrementQty() {
      this.currentQTY++;
      if (this.currentQTY > 9999) this.currentQTY = 9999;
    },
    decrementQty() {
      if (this.currentQTY - 1 > 0) this.currentQTY--;
    },
    async openCashDrawer() {
      try {
        await this.fp.CashDrawerOpen();
      } catch (ex) {
        this.fp.handleException(ex);
      } finally {
        this.isWorking = false;
      }
    },
    async getScaleQty() {
      this.isScaleMeasuring = true;
      if (this.isWorking) {
        setTimeout(async () => {
          await this.getScaleQty();
        }, 50);
      } else {
        this.isWorking = true;
        try {
          var qty = await this.fp.GetScaleQuantity();
          if (qty > 0) {
            this.currentQTY = qty;
            // this.dialogScale = true;
            // setTimeout(() => {
            //   this.dialogScale = false;
            // }, 1000);
          } else {
            this.fp.setErrorMessage("Измерено е нулево или отрицателно количество");
          }
        } catch (ex) {
          this.fp.handleException("Грешка при измерване!" + ex);
        } finally {
          this.isWorking = false;
          setTimeout(() => {
            this.isScaleMeasuring = false;
          }, 789);
        }
      }
    },
    getReceiptAmount() {
      if (this.receiptArticles == null) return 0;
      return this.roundTo(
        this.receiptArticles
          .map((a) => a.Sum) //a.Price * a.Quantity)
          .reduce(function (a, b) {
            return a + b;
          }, 0),
        2
      );
    },
    cancelDialogs() {
      this.dialogSellArticle = false;
      this.dialogFullscreen = false;
      this.dialogFreePrice = false;
      this.$refs.refSearchTextField.focus();
    },
    async clearReceiptData() {
      this.receiptTypeStr = this.receiptTypes.Sale;
      this.receiptArticles = [];
      this.receiptWasCanceled = false;
      this.receiptPaymentAmount = 0;
      this.currentPayment = 0;
      this.currentPaymentType = this.paymentTypes[0];
      this.receiptIsOpen = false;
    },
    async sell(plu, correction) {
      if (this.isPaymentStarted == true || this.isScaleMeasuring == true) {
        return;
      }
      if (this.fp.IsWorking() == true) {
        return;
      }
      if (this.wasMoved) {
        this.wasMoved = false;
        return;
      }
      if (this.currentArticle != plu) {
        this.currentArticle = plu;
      }
      var w = this.isWorking;
      this.isWorking = true;
      try {
        if (w) {
          setTimeout(async () => {
            return await this.sell(plu, correction);
          }, 10);
          return;
        }
        if (plu.Price == 0) {
          this.fp.setErrorMessage("Нулева цена на артикул!");
          this.isWorking = false;
          return;
        }
        if (!this.receiptArticles || !this.receiptIsOpen) {
          var devIsThere = false;
          await this.fp.executeWithLoader(async () => {
            devIsThere = await this.checkCancelReceipt(true);
          }, "Проверка за отворен бон...");
          if (!devIsThere) {
            this.isWorking = false;
            return;
          }
          var dtOK = await this.fp.checkDateAndTime();
          if (!dtOK) {
            this.isWorking = false;
            return;
          }
          await this.fp.executeWithLoader(async () => {
            await this.fp.ExtDisplayClear();
            await this.fp.OpenReceipt(1, this.fp.operator1pass, this.uiSettings.receiptFormat, this.uiSettings.printVatInReceipt, Tremol.Enums.OptionFiscalRcpPrintType.Step_by_step_printing);
            await this.clearReceiptData();
            this.receiptIsOpen = true;
          }, "Отваряне на фискален бон...");
        }
        if (correction) {
          var idx = this.receiptArticles.indexOf(plu);
          if (idx > -1) {
            await this.fp.SellPLUFromFD_DB(Tremol.Enums.OptionSign.Correction, plu.PLUNum, plu.FreePrice, plu.Quantity);
            await this.fp.ExternalDisplayShowItem("~КОРЕКЦИЯ~ " + plu.PLUName, null, " * " + plu.Quantity.toFixed(3) + " = ", -(plu.Quantity * (this.freePrice ?? plu.Price)).roundTo(2));
            this.receiptArticles.splice(idx, 1);
          }
        } else {
          plu.Quantity = this.currentQTY;
          plu.Sum = this.roundTo(plu.Quantity * (plu.OptionPrice && this.freePrice ? this.freePrice : plu.Price), 2);
          await this.fp.SellPLUFromFD_DB(Tremol.Enums.OptionSign.Sale, plu.PLUNum, plu.OptionPrice ? this.freePrice : null, plu.Quantity);
          if (this.getReceiptAmount() <= this.receiptMaximumAmount && this.getReceiptAmount() + plu.Sum > this.receiptMaximumAmount) {
            this.fp.setErrorMessage("Сумата по бона надвишава " + this.receiptMaximumAmount + " €!");
          }
          await this.fp.ExternalDisplayShowItem(plu.PLUName, null, " * " + plu.Quantity.toFixed(3) + " = ", plu.Sum);
          this.receiptClass = "";
          var pluClone = Object.assign({}, plu);
          if (pluClone.OptionPrice && this.freePrice) {
            pluClone.FreePrice = this.freePrice;
          }
          this.receiptArticles.push(pluClone);
          this.$nextTick(() => {
            this.receiptClass = "receiptanimation";
            setTimeout(() => {
              this.receiptClass = "";
            }, 600);
          });
        }
        this.freePrice = null;
        this.currentQTY = 1;
        if (!correction) {
          this.$nextTick(() => {
            let receiptDiv = this.$el.querySelector("#receiptDiv");
            if (receiptDiv != null) receiptDiv.scrollTop = receiptDiv.scrollHeight - receiptDiv.clientHeight;
          });
        }
      } catch (ex) {
        this.fp.handleException(ex);
      }
      this.isWorking = false;
    },
    async wantToPay(kbd) {
      if (this.isWorking) {
        setTimeout(async () => {
          return await this.wantToPay(kbd);
        }, 10);
        return;
      }
      this.isWorking = true;
      if (kbd) this.searchText = "";
      if (this.isPaymentStarted && this.isPaymentFinished) {
        await this.closeReceipt();
      } else if (this.currentPayment == 0) {
        if (this.currentPaymentType.currencyRate) {
          this.currentPayment = this.roundTo((this.receiptAmount - this.receiptPaymentAmount) / this.currentPaymentType.currencyRate, 2);
        } else {
          this.currentPayment = this.receiptAmount - this.receiptPaymentAmount;
        }
      } else {
        await this.pay();
        this.currentPayment = 0;
      }
      this.isWorking = false;
    },
    async pay() {
      await this.fp.executeWithLoader(async () => {
        try {
          var pAmount = this.roundTo(this.currentPayment, 2);
          var amount = await this.fp.Subtotal(Tremol.Enums.OptionPrinting.No, Tremol.Enums.OptionDisplay.Yes);
          await this.fp.Payment(this.currentPaymentType.getFDCode(), Tremol.Enums.OptionChange.With_Change, pAmount, Tremol.Enums.OptionChangeType.Change_In_Cash);
          this.fp.Ext_WaitIfBusy(100000);
          var amount2 = await this.fp.Subtotal(Tremol.Enums.OptionPrinting.No, Tremol.Enums.OptionDisplay.Yes);
          if (amount != amount2) {
            if (this.currentPaymentType.currencyRate) {
              this.receiptPaymentAmount += this.roundTo(pAmount * this.currentPaymentType.currencyRate, 2);
            } else {
              this.receiptPaymentAmount += pAmount;
            }
          } else {
            throw new Error("Неуспешно плащане с карта!");
          }
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }, "Извършване на плащане...");
      if (this.isPaymentFinished && this.uiSettings.closeAfterPayment) {
        await this.closeReceipt();
      }
    },
    async closeReceipt() {
      try {
        //this.isWorking = true;
        await this.fp.executeWithLoader(async () => {
          var change = this.receiptPaymentAmount - this.getReceiptAmount();
          await this.fp.ExternalDisplayShowItem("От клиента:", this.receiptPaymentAmount, change > 0 ? "Ресто:" : "", change > 0 ? change : null);
          await this.fp.CloseReceipt();
          this.receiptIsOpen = false;
          this.currentQTY = 1;
          this.currentArticle = null;
          this.displayGreetings();
        }, "Затваряне на бона...");
      } catch (ex) {
        this.fp.handleException(ex);
      }
      //this.isWorking = false;
    },
    async cancelPayments() {
      await this.fp.executeWithLoader(async () => {
        try {
          await this.fp.Payment(this.currentPaymentType.getFDCode(), Tremol.Enums.OptionChange.With_Change, -this.receiptAmount, Tremol.Enums.OptionChangeType.Change_In_Cash);
          this.receiptPaymentAmount = 0;
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }, "Отказ на плащанията....");
    },
    async cancelReceipt(showError) {
      await this.fp.executeWithLoader(async () => {
        await this.checkCancelReceipt(showError);
        this.displayGreetings();
      }, "Отказ на бона....");
    },
    async displayGreetings(first) {
      if (this.displayTO) {
        clearTimeout(this.displayTO);
      }
      this.displayTO = setTimeout(async () => {
        if (this.isWorking || this.receiptIsOpen) {
          return;
        }
        try {
          if (first) {
            await this.fp.ExternalDisplayShowItem(`    "ТРЕМОЛ" ООД    `, null, "", null);
          } else {
            await this.fp.ExternalDisplayShowItem("    Tremol  Echo    ", null, "", null);
          }
        } catch {
          /** ignored */
        }
        this.displayGreetings(!first);
      }, 10000);
    },
    async checkCancelReceipt(showError) {
      try {
        var st = await this.fp.ReadStatus();
        if (st.Opened_Fiscal_Receipt || st.Opened_Non_fiscal_Receipt || st.Opened_Invoice_Fiscal_Receipt) {
          if (showError) {
            this.fp.loadingMessage = "ФУ е в състояние на отворен бон. Опит за анулиране на бона...";
          }
          try {
            await this.fp.CancelReceipt();
            this.receiptWasCanceled = true;
            if (showError) {
              this.fp.setErrorMessage("ФУ е било в състояние на отворен бон. Бона е анулиран.", false, true);
            }
          } catch {
            if (showError) {
              this.fp.loadingMessage = "ФУ е в състояние на отворен бон, който не може да се анулира. Бона ще бъде довършен в брой!";
            }
            await this.fp.CashPayCloseReceipt();
            this.fp.setErrorMessage("ФУ е било в състояние на отворен бон, който не може да се анулира.\nБона е довършен в брой!", false, true);
          }
          this.receiptIsOpen = false;
          this.currentArticle = null;
          this.currentQTY = 1;
        }
        return true;
        //await this.clearReceiptData();
      } catch (ex) {
        this.fp.handleException(ex);
        return false;
      }
    },
    async readReceiptInfo() {
      try {
        var recInfo = await this.fp.ReadCurrentReceiptInfo();
        if (recInfo.OptionIsReceiptOpened == Tremol.Enums.OptionIsReceiptOpened.Yes) {
          await this.clearReceiptData();
          switch (recInfo.OptionTypeReceipt) {
            case Tremol.Enums.OptionTypeReceipt.Sales_receipt_Postponed_Printing:
            case Tremol.Enums.OptionTypeReceipt.Sales_receipt_printing_step_by_step:
              this.receiptTypeStr = this.receiptTypes.Sale;
              break;
            case Tremol.Enums.OptionTypeReceipt.Invoice_sales_receipt_Postponed_Printing:
            case Tremol.Enums.OptionTypeReceipt.Invoice_sales_receipt_printing_step_by_step:
              this.receiptTypeStr = this.receiptTypes.Invoice;
              break;
            case Tremol.Enums.OptionTypeReceipt.Storno_receipt_Postponed_Printing:
            case Tremol.Enums.OptionTypeReceipt.Storno_receipt_printing_step_by_step:
              this.receiptTypeStr = this.receiptTypes.Storno;
              this.currentPaymentType = this.paymentTypes[0];
              break;
            case Tremol.Enums.OptionTypeReceipt.Invoice_Credit_note_receipt_Postponed_Printing:
            case Tremol.Enums.OptionTypeReceipt.Invoice_Credit_note_receipt_printing_step_by_step:
              this.receiptTypeStr = this.receiptTypes.CreditNote;
              this.currentPaymentType = this.paymentTypes[0];
              break;
          }
          this.receiptIsOpen = true;
        }
        return true;
      } catch (ex) {
        this.fp.handleException(ex);
        return false;
      }
    },
    async readClients(firstTime) {
      try {
        if (this.uiSettings.clientsLimit != Const.ClientsLimits[0]) {
          this.clientsCount = Number(Const.ClientsLimits[Const.ClientsLimits.indexOf(this.uiSettings.clientsLimit)]);
        }
        if (this.clientsCount > this.fp.maxSupportedClients) {
          this.clientsCount = this.fp.maxSupportedClients;
        }

        this.isLoading = true;
        this.fp.clients = [];
        let clientsTemp = [];
        this.loaderText = "";
        this.loaderValue = 0;
        for (var i = 1; i <= this.clientsCount; i++) {
          this.loaderText = `Клиент ${i} от ${this.clientsCount}`;
          var clientRes = null;
          clientRes = await this.fp.ReadCustomerData(i);
          this.loaderValue++;
          if (this.uiSettings.clientsLimit == Const.ClientsLimits[0] && clientRes.CustomerCompanyName.trim() == "") {
            break;
          }
          clientRes.CustomerCompanyName = clientRes.CustomerCompanyName.trim();
          clientRes.CustomerFullName = clientRes.CustomerFullName.trim();
          clientRes.Address = clientRes.Address.trim();
          clientRes.VATNumber = clientRes.VATNumber.trim();
          clientRes.UIC = clientRes.UIC.trim();
          clientsTemp.push(clientRes);
          if (!this.isLoading) {
            break;
          }
        }
        clientsTemp.forEach((c) => {
          this.fp.clients.push(c);
        });
        clientsTemp = [];
        this.isLoading = false;
        if (firstTime && !this.uiSettings.noFullScreen) {
          this.dialogFullscreen = true;
        }
        return true;
      } catch (ex) {
        this.fp.handleException(ex);
        return false;
      }
    },
    async readDepartments() {
      try {
        this.isLoading = true;
        this.fp.departments = [{ DepNum: 0, DepName: "Няма" }];
        this.loaderText = "";
        this.loaderValue = 0;
        for (var i = 1; i <= this.fp.maxSupportedDeps; i++) {
          this.loaderText = `Департамент ${i} от ${this.fp.maxSupportedDeps}`;
          const num = i.toString().padStart(2, "0");
          var dep = await this.fp.ReadDepartment(num);
          this.loaderValue++;
          dep.DepName = dep.DepName.trim();
          // if (dep.DepName.toUpperCase().startsWith("ДЕП") && dep.DepName.endsWith(num)) {
          //   break;
          // }
          this.fp.departments.push(dep);
          if (!this.isLoading) {
            break;
          }
        }
        this.isLoading = false;
        return true;
      } catch (ex) {
        this.fp.handleException(ex);
        return false;
      }
    },

    async readArticles() {
      try {
        if (this.uiSettings.articleLimit != Const.ArticleLimits[0]) {
          if (this.uiSettings.articleLimit == Const.ArticleLimits[1]) {
            this.articleFrom = this.uiSettings.articleFrom;
            this.articleTo = this.uiSettings.articleTo;
          } else {
            this.articleTo = Number(Const.ArticleLimits[Const.ArticleLimits.indexOf(this.uiSettings.articleLimit)]);
          }
        }
        if (this.articleTo > this.fp.maxSupportedArts) {
          this.articleTo = this.fp.maxSupportedArts;
        }

        this.searchText = "";
        this.isLoading = true;
        this.fp.articles = [];
        this.loaderText = "";
        this.loaderValue = 0;
        for (var i = this.articleFrom; i <= this.articleTo; i++) {
          this.loaderText = `Артикул ${i} от ${this.articleTo}`;
          var plu = null;
          if (this.fp.isNew) {
            plu = await this.fp.ReadPLUallData(i);
            plu.OptionPrice = Number(plu.FlagsPricePLU) - 0x80;
          } else {
            plu = await this.fp.ReadPLU_Old(i);
            plu.OptionPrice = 1;
            plu.Barcode = (await this.fp.ReadPLUbarcode(i)).Barcode;
          }
          this.loaderValue++;
          if (this.uiSettings.articleLimit == Const.ArticleLimits[0] && plu.Price == 0) {
            break;
          }
          plu.PLUName = plu.PLUName.trim();
          plu.Barcode = plu.Barcode.trim();
          if (plu.Price > 0 && plu.OptionVATClass >= "А" && plu.OptionVATClass <= "Г") {
            plu.isVisible = true;
          }

          //var imgUrl = "http://localhost/Pics/" + i + ".png";
          // fetch(new URL(imgUrl))
          //   .then((r) => {
          //     console.log(r);
          //   })
          //   .catch((err) => {
          //     console.log("error while loading image");
          //     console.log(err);
          //   });

          this.fp.articles.push(plu);
          if (!this.isLoading) {
            break;
          }
        }

        this.isLoading = false;

        return true;
      } catch (ex) {
        this.fp.handleException(ex);
        return false;
      }
    },

    async goLoadAll() {
      this.fp.externalDisplayPort = this.uiSettings.externalDisplayPort;
      this.fp.externalDisplayCodePage = this.uiSettings.externalDisplayCodePage;
      this.fp.scaleType = this.uiSettings.scaleType;
      this.fp.scalePort = this.uiSettings.scalePort;
      if ((await this.readReceiptInfo()) == true) {
        try {
          var paymentZ = await this.fp.Ext_GetNRAPayments(this.fp.isNew, null);
          this.paymentTypes = Object.values(paymentZ)
            .filter((p) => p.fdname != null && p.fdcode != null)
            .sort((a, b) => a.fdcode - b.fdcode);
          this.currentPaymentType = this.paymentTypes[0];
          await this.cancelReceipt(true);
          if (this.fp.departments.length == 0) {
            await this.readDepartments();
          }
          if (this.fp.articles.length == 0) {
            this.articleLimit = this.uiSettings.articleLimit;
            if (await this.readArticles()) {
              if (this.fp.articles.length == 0) {
                this.fp.setErrorMessage("Няма програмирани артикули. Може да ги програмирате от меню 'Операции' -> 'Програмиране на артикули'.");
              } else if (this.fp.clients.length == 0) {
                this.clientsLimit = this.uiSettings.clientsLimit;
                await this.readClients(true);
              }
            }
          }
          await this.fp.checkDateAndTime();
        } catch (ex) {
          this.dialogFullscreen = true;
          this.fp.handleException(ex);
        }
      }
    },
    async printDuplicate() {
      try {
        await this.fp.executeWithLoader(async () => {
          await this.fp.PrintLastReceiptDuplicate();
        }, "Отпечатване на дубликат...");
      } catch (ex) {
        if (ex instanceof Tremol.ServerError && ex.isFpException && ex.ste1 === 0x30 && ex.ste2 === 0x32) {
          this.fp.setErrorMessage("Командата е непозволена в текущото състояние на ФУ.\nМоля, проверете параметъра за печат на дубликат.");
        } else {
          this.fp.handleException(ex);
        }
      }
    },

    // getTouches(evt) {
    //   console.log("getTouches");
    //   console.log(evt);
    //   return (
    //     evt.touches || // browser API
    //     evt.originalEvent.touches
    //   ); // jQuery
    // },

    handleTouchStart(evt) {
      if (this.uiSettings.touchScreenMode) {
        this.xDown = evt.clientX;
        this.yDown = evt.clientY;
        this.wasMoved = false;
      }
    },

    handleTouchEnd() {
      setTimeout(() => {
        this.xDown = null;
        this.yDown = null;
        this.wasMoved = false;
      }, 200);
    },

    handleReceiptTouchMove(evt) {
      if (!this.uiSettings.touchScreenMode || !this.xDown || !this.yDown) {
        // if (!this.xDown || !this.yDown) {
        return;
      }
      try {
        if (evt.movementY) {
          this.$el.querySelector("#receiptDiv").scrollTop -= evt.movementY;
        }
      } catch {
        console.log("SCROLLING ERROR!\n");
        console.log(evt);
      }
    },

    handleTouchMove(evt) {
      if (!this.uiSettings.touchScreenMode || !this.xDown || !this.yDown) {
        // if (!this.xDown || !this.yDown) {
        return;
      }
      try {
        if (!this.wasMoved && Math.abs(evt.movementY) > 5) {
          this.wasMoved = true;
        }
        if (this.wasMoved) {
          switch (this.getViewTypeIndex) {
            case 0:
            case 1:
            case 2:
              if (evt.movementY) {
                this.$refs.refVirtualScroller.$el.scrollTop -= evt.movementY;
              }
              break;

            case 3:
            case 4:
            default:
              if (evt.movementY) {
                this.$refs.refTableScrollContent.$el.scrollTop -= evt.movementY;
              }
              break;
          }
        }
      } catch {
        console.log("SCROLLING ERROR!\n");
        console.log(evt);
      }

      // var xUp = evt.touches[0].clientX;
      // var yUp = evt.touches[0].clientY;
      // var xDiff = this.xDown - xUp;
      // var yDiff = this.yDown - yUp;
      // if (Math.abs(xDiff) > Math.abs(yDiff)) {
      //   /*most significant*/
      //   if (xDiff > 0) {
      //     console.log("move right");
      //   } else {
      //     console.log("move left");
      //   }
      // } else {
      //   if (yDiff > 0) {
      //     console.log("move down");
      //   } else {
      //     console.log("move up");
      //   }
      // }
      // /* reset values */
      // this.xDown = null;
      // this.yDown = null;
    },
  },
  created() {},
  watch: {
    "fp.mode": async function (newVal, oldVal) {
      if ((newVal |= Const.Modes.Settings) == oldVal && (this.articleLimit != this.uiSettings.articleLimit || this.articleFrom != this.uiSettings.articleFrom || this.articleTo != this.uiSettings.articleTo)) {
        this.articleLimit = this.uiSettings.articleLimit;
        await this.readDepartments();
        await this.readArticles();
      }
      if ((newVal |= Const.Modes.Settings) == oldVal && this.clientsLimit != this.uiSettings.clientsLimit) {
        this.clientsLimit = this.uiSettings.clientsLimit;
        await this.readClients(false);
      }
    },
    "fp.serialNumber": async function (newVal, oldVal) {
      if (!!newVal && oldVal != newVal) {
        await this.readDepartments();
        await this.readArticles();
        await this.readClients(false);
      }
    },
    "uiSettings.viewType": function () {
      this.recalcWidthHeight();
    },
  },
  mounted() {
    this.recalcWidthHeight();
    window.addEventListener("resize", this.recalcWidthHeight);
    // var v = new HTTPSender();
    //  var asd = v.SendGETreq("https://api.ipify.org?format=jsonp&callback=?").;
    // console.log(JSON.stringify(asd))
    // $.getJSON("https://api.ipify.org?format=jsonp&callback=?", function (data) {
    //   console.log(data.ip);
    // });

    this.$nextTick(() => {
      if (this.$refs.refButtonsContainer) {
        this.$refs.refButtonsContainer.removeEventListener("mousedown", this.handleTouchStart);
        this.$refs.refButtonsContainer.removeEventListener("mouseup", this.handleTouchEnd);
        this.$refs.refButtonsContainer.removeEventListener("mousemove", this.handleTouchMove);
        this.$refs.refButtonsContainer.addEventListener("mousedown", this.handleTouchStart, false);
        this.$refs.refButtonsContainer.addEventListener("mouseup", this.handleTouchEnd, false);
        this.$refs.refButtonsContainer.addEventListener("mousemove", this.handleTouchMove, false);
      }

      //на мобилно я няма
      if (this.$refs.refReceiptContainer) {
        this.$refs.refReceiptContainer.removeEventListener("mousedown", this.handleTouchStart);
        this.$refs.refReceiptContainer.removeEventListener("mouseup", this.handleTouchEnd);
        this.$refs.refReceiptContainer.removeEventListener("mousemove", this.handleReceiptTouchMove);
        this.$refs.refReceiptContainer.addEventListener("mousedown", this.handleTouchStart, false);
        this.$refs.refReceiptContainer.addEventListener("mouseup", this.handleTouchEnd, false);
        this.$refs.refReceiptContainer.addEventListener("mousemove", this.handleReceiptTouchMove, false);
      }
    });
    this.goLoadAll();
  },
  updated() {
    this.recalcWidthHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcWidthHeight);
    if (this.$refs.refButtonsContainererElement) {
      this.$refs.refButtonsContainer.removeEventListener("mousedown", this.handleTouchStart);
      this.$refs.refButtonsContainer.removeEventListener("mouseup", this.handleTouchEnd);
      this.$refs.refButtonsContainer.removeEventListener("mousemove", this.handleTouchMove);
    }
    if (this.$refs.refReceiptContainer) {
      this.$refs.refReceiptContainer.removeEventListener("mousedown", this.handleTouchStart);
      this.$refs.refReceiptContainer.removeEventListener("mouseup", this.handleTouchEnd);
      this.$refs.refReceiptContainer.removeEventListener("mousemove", this.handleReceiptTouchMove);
    }
  },

  destroyed() {},
};
</script>
<style scoped>
.centered-input .append-prepend-icon {
  margin-top: -8px;
}

.dark .my-selected-row {
  background: #4f4f4f;
  /* border: 2px solid lightskyblue; */
}
.light .my-selected-row {
  background: rgb(200, 236, 250);
  /* border: 2px solid lightskyblue; */
}

* >>> .v-menu__content {
  display: flex;
  max-height: 800px;
  flex-direction: column;
  flex: 1;
}
div >>> .v-expansion-panel-content__wrap {
  padding-left: 0px;
  padding-right: 0px;
}

.fullheightparentcontainer {
  display: flex;
  height: 100%;
  min-height: 100%;
  flex-direction: column;
}

.growingchildcontainer {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.custom-table-row:hover {
  border: 1px solid gray;
  border-radius: 3px;
}

.custom-table-row:active {
  border: 2px solid gray;
  border-radius: 6px;
}

.v-progress-circular {
  margin: 1rem;
}

.card-outter {
  position: relative;
  padding-bottom: 50px;
}

.salecontainer {
  position: absolute;
  overflow-x: hidden;
  /* overflow-y: auto; */
}

.inner-pre {
  justify-content: center;
}

.my-table-cell {
  line-height: 1.2;
  display: table-cell;
  vertical-align: middle;
  font-size: 14px;
  height: inherit;
  margin: 0 !important;
}

.receiptanimation {
  -moz-animation: mykeyframes 0.6s;
  -webkit-animation: mykeyframes 0.6s;
  animation: mykeyframes 0.6s;
}

@-moz-keyframes mykeyframes {
  0% {
    transform: translateY(80px);
  }
  100% {
    transform: translateY(0px);
  }
}

@-webkit-keyframes mykeyframes {
  0% {
    transform: translateY(80px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes mykeyframes {
  0% {
    transform: translateY(80px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>